import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import IntlMessages from "../../../util/IntlMessages";
import {tagVectorCommentAdd} from "../../../actions";
import {useDispatch} from "react-redux";
import {Button, Col, Row} from "reactstrap";
import {TextField} from "@material-ui/core";

const AddCommentsForm = ({customerId=null,
                             vectorId= null,
                             entityId=null,
                             testedVectorId=null,})=>{

    const [commentValue, setCommentValue] = useState(null);

    const dispatch = useDispatch();

    const clearForm = () => {
        setCommentValue("");
        // document.getElementById('NewCommentForm').reset();
    }

    const { register, handleSubmit, errors } = useForm();

    const onSubmit = data => {
        console.log("dispatch add comment tag")
        dispatch(tagVectorCommentAdd(
                customerId,
                entityId,
                vectorId,
                testedVectorId,
                commentValue
            )
        )
        clearForm()
    }
    return(
        // <div>
            <form id={"NewCommentForm"} className={"col-12"}>
                    <TextField
                        label={"New Comment..."}
                        id="commentValue"
                        name="commentValue"
                        required
                        error={!!errors.commentValue}
                        onChange={(event) => setCommentValue(event.target.value)}
                        defaultValue={commentValue}
                        margin="normal"
                        className="mt-1 my-sm-3 col-12"
                        inputRef={register({
                            required: "This field is required." ,

                        })}
                        helperText={errors.firstName?.message}
                    />

                    <Button onClick={handleSubmit(onSubmit)}
                            disabled={!!errors.commentValue}
                            variant="contained" color="primary"
                            style={{float: "right"}}
                            type="submit">
                        <IntlMessages id="form.submit"/>
                    </Button>
                <br/>
                <Row/>
            </form>
        // </div>
    )
}

export default AddCommentsForm;